import { gql } from '@apollo/client';

export const USERS_PAGE_QUERY = gql`
  query users(
    $limit: Int!
    $offset: Int!
    $withDeleted: Boolean
    $q: String
    $orderBy: String
    $orderDirection: String
    $columnFilters: [ColumnFilter!]
  ) {
    users(
      limit: $limit
      offset: $offset
      withDeleted: $withDeleted
      q: $q
      orderBy: $orderBy
      orderDirection: $orderDirection
      columnFilters: $columnFilters
    ) {
      id
      email
      firstName
      lastName
      login
      roles {
        id
        name
        deletedAt
      }
      filteringRuleGroups {
        id
        name
        deletedAt
      }
      timezoneId
      deletedAt
    }
    usersPageInfo(q: $q, columnFilters: $columnFilters, withDeleted: $withDeleted) {
      totalCount
    }
  }
`;

export const USERS_QUERY = gql`
  query users($limit: Int!, $offset: Int!, $q: String, $withDeleted: Boolean) {
    users(limit: $limit, offset: $offset, q: $q, withDeleted: $withDeleted) {
      id
      deletedAt
      email
      firstName
      lastName
      login
      roles {
        id
        name
        deletedAt
      }
      filteringRuleGroups {
        id
        name
        deletedAt
      }
      timezoneId
    }
  }
`;

export const USER_QUERY_BASE = `
  query user($id: Int) {
    user(id: $id) {
      id
      email
      firstName
      lastName
      login
      desktopVersion
      mobileAppVersion
      mobileDeviceInfo
      active
      isThirdPartyUser
      roles {
        id
        name
        deletedAt
      }
      filteringRuleGroups {
        id
        name
        deletedAt
      }
      timezoneId
      deletedAt
      needPasswordUpdate
    }
  }
`;

export const USER_QUERY = gql`${USER_QUERY_BASE}`;
